import {
  INITIAL_ORDER,
  INITIAL_PAGE_NUMBER,
  INITIAL_SIZE,
  INITIAL_SORT
} from '../../constants/general';

export default function jobs(
  initialState = {
    jobs: [],
    pageNumber: INITIAL_PAGE_NUMBER,
    search: '',
    jobPageData: {},
    size: INITIAL_SIZE,
    totalRecords: 0,
    sortBy: INITIAL_SORT.JOB,
    orderBy: INITIAL_ORDER.JOB
  },
  action
) {
  switch (action.type) {
    case 'SET_JOBS':
      return {
        ...initialState,
        jobs: action.payload
      };

    case 'SET_JOBS_SEARCH':
      return {
        ...initialState,
        search: action.payload
      };

    case 'SET_JOBS_SINGLE_JOB_DATA':
      return {
        ...initialState,
        jobPageData: action.payload
      };

    case 'SET_JOBS_PAGE_NUMBER':
      return {
        ...initialState,
        pageNumber: action.payload
      };

    case 'SET_JOBS_PAGE_SIZE':
      return {
        ...initialState,
        size: action.payload
      };

    case 'SET_JOBS_SORT_BY':
      return {
        ...initialState,
        sortBy: action.payload
      };

    case 'SET_JOBS_ORDER_BY':
      return {
        ...initialState,
        orderBy: action.payload
      };

    case 'SET_JOBS_TOTAL_RECORDS':
      return {
        ...initialState,
        totalRecords: action.payload
      };

    case 'JOBS_RESET':
      return {
        ...initialState,
        jobs: [],
        pageNumber: INITIAL_PAGE_NUMBER,
        search: '',
        jobPageData: {},
        size: INITIAL_SIZE,
        totalRecords: 0,
        sortBy: INITIAL_SORT.JOB,
        orderBy: INITIAL_ORDER.JOB
      };

    default:
      return initialState;
  }
}
